import styled from 'styled-components';
import { OCardLayeredFeatureImageScale } from './OCardLayeredFeature.types';

const getImageScaleHeight = (scale: OCardLayeredFeatureImageScale) => {
  switch (scale) {
    case OCardLayeredFeatureImageScale.Small:
      return '400px';
    case OCardLayeredFeatureImageScale.Medium:
      return '500px';
    case OCardLayeredFeatureImageScale.Large:
      return '600px';
    default:
      return '500px';
  }
};

const getImageScaleHeightTablet = (scale: OCardLayeredFeatureImageScale) => {
  switch (scale) {
    case OCardLayeredFeatureImageScale.Small:
      return '450px';
    case OCardLayeredFeatureImageScale.Medium:
      return '550px';
    case OCardLayeredFeatureImageScale.Large:
      return '650px';
    default:
      return '550px';
  }
};

const getImageScaleHeightDesktop = (scale: OCardLayeredFeatureImageScale) => {
  switch (scale) {
    case OCardLayeredFeatureImageScale.Small:
      return '500px';
    case OCardLayeredFeatureImageScale.Medium:
      return '600px';
    case OCardLayeredFeatureImageScale.Large:
      return '700px';
    default:
      return '600px';
  }
};

export const CardWrapper = styled.article<{
  $imageScale: OCardLayeredFeatureImageScale;
  $isClickable: boolean;
}>`
  position: relative;
  width: 100%;
  min-height: ${({ $imageScale }) => getImageScaleHeight($imageScale)};
  overflow: hidden;
  border-radius: var(--t-cards-border-radius, 14px);
  cursor: ${({ $isClickable }) => ($isClickable ? 'pointer' : 'default')};
  transition: transform 0.3s ease;

  &:hover {
    transform: ${({ $isClickable }) => ($isClickable ? 'scale(1.01)' : 'none')};
  }

  @media (min-width: 768px) {
    min-height: ${({ $imageScale }) => getImageScaleHeightTablet($imageScale)};
  }

  @media (min-width: 992px) {
    min-height: ${({ $imageScale }) => getImageScaleHeightDesktop($imageScale)};
  }
`;

export const ImageContainer = styled.div<{
  $imageScale: OCardLayeredFeatureImageScale;
}>`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  z-index: 1;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
`;

export const ScrimWrapper = styled.div`
  position: absolute;
  inset: 0;
  z-index: 2;
  pointer-events: none;
`;

export const ContentOverlay = styled.div<{
  $imageScale: OCardLayeredFeatureImageScale;
}>`
  position: absolute;
  z-index: 3;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  min-height: auto;
  padding: 1.5rem;
  gap: 1rem;

  top: 50%;
  left: 5%;
  transform: translate(0, -50%);

  @media (min-width: 768px) {
    padding: 2rem;
    gap: 1.25rem;
  }

  @media (min-width: 992px) {
    padding: 2.5rem;
    gap: 1.5rem;
  }
`;

export const LogoWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  margin-block-end: auto;
`;

export const TextBlockWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

export const PhotoCaptionWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-block-start: auto;
`;
